import {
  Stack,
  Table,
  TableCaption,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr
} from "@chakra-ui/react";
import React from "react";

import {
  Expense,
  Investigation,
  Patient,
  Person,
  Voucher,
  VoucherRecord
} from "app/api/type";
import { PageCardComponent } from "modules/core/components/page-card.component";

interface PaymentVoucherComponentProps {
  voucherDetails: {
    patient: Patient | null;
    person: Person | null;
    voucher: Voucher;
    entries: {
      voucherRecord: VoucherRecord;
      investigation: Investigation | null;
      expense: Expense | null;
    }[];
  };
}

export const PaymentVoucherComponent: React.FC<PaymentVoucherComponentProps> = (
  props: PaymentVoucherComponentProps
) => {
  return (
    <Stack>
      <Stack spacing="6">
        <PageCardComponent>
          <TableContainer>
            <Table variant="simple" size="sm">
              <TableCaption placement="top">
                Voucher {props.voucherDetails.voucher.id}
              </TableCaption>
              <Thead>
                <Tr>
                  <Th>Sl.</Th>
                  <Th width="30%">Item Name</Th>
                  <Th>Base Price</Th>
                  <Th>Quantity</Th>
                  <Th>Sub-Total</Th>
                </Tr>
              </Thead>

              <Tbody>
                {props.voucherDetails.entries.map((voucherEntry, index) => {
                  return (
                    <Tr>
                      <Td>{index + 1}</Td>
                      <Td>
                        {voucherEntry.investigation
                          ? voucherEntry.investigation.name
                          : "Unknown"}
                      </Td>
                      <Td>৳ {voucherEntry.voucherRecord.basePrice}</Td>
                      <Td>{voucherEntry.voucherRecord.quantity}</Td>
                      <Td>৳ {voucherEntry.voucherRecord.totalPrice}</Td>
                    </Tr>
                  );
                })}
                <Tr bgColor="gray.600" color="white" fontWeight={"bold"}>
                  {" "}
                  <Td></Td>
                  <Td>Grand Total </Td>
                  <Td></Td>
                  <Td>=</Td>
                  <Td>
                    ৳{" "}
                    {props.voucherDetails.entries.reduce(
                      (totalPrice, voucherEntry) =>
                        totalPrice + voucherEntry.voucherRecord.totalPrice,
                      0
                    )}
                  </Td>
                  <Td></Td>
                </Tr>
                <Tr bgColor="gray.100" fontWeight={"bold"}>
                  {" "}
                  <Td></Td>
                  <Td>Paid </Td>
                  <Td></Td>
                  <Td>=</Td>
                  <Td>৳ {props.voucherDetails.voucher.paidAmount}</Td>
                  <Td></Td>
                </Tr>{" "}
                {/* <Tr bgColor="gray.100" fontWeight={"bold"}>
                    <Td></Td>
                    <Td>Due </Td>
                    <Td></Td>
                    <Td></Td>
                    <Td></Td>
                    <Td>=</Td>
                    <Td>৳ {props.voucherDetails.voucher.dueAmount}</Td>
                    <Td></Td>
                  </Tr> */}
              </Tbody>
            </Table>
          </TableContainer>
        </PageCardComponent>
        <Stack direction="row">
          {/* <CollectPaymentModalComponent
              voucherId={props.voucherId}
              dueAmount={props.voucherDetails.voucher.dueAmount}
            /> */}
        </Stack>
      </Stack>
    </Stack>
  );
};
